import type { ConfiguratorPageDefinition } from "~/features/configurator/ConfiguratorPageDefinition";

// Product code -> Configurator
const CONFIGURATORS = {} as Record<string, ConfiguratorPageDefinition>;

export function getConfiguratorDefinition(productCode: string): ConfiguratorPageDefinition {
  return CONFIGURATORS[productCode];
}

export function getAllConfiguratorDefinitions(): ConfiguratorPageDefinition[] {
  return Object.values(CONFIGURATORS);
}

export function registerConfiguratorDefinition(definition: ConfiguratorPageDefinition) {
  if (CONFIGURATORS[definition.productCode]) {
    console.warn(`Configurator registry: Overriding an already registered component at ${definition.productCode}`);
  }
  CONFIGURATORS[definition.productCode] = definition;
}
